import { Directive, Injectable } from '@angular/core';

import { OpenStrategy, provideOpenStrategy, StrategyRelevance } from './types';

@Injectable()
export class AlwaysOpenStrategy extends OpenStrategy {
  public override init() {
    this.dropdownTemplateVcRef.createEmbeddedView(this.dropdownTemplate);
  }
}

@Directive({
  standalone: true,
  selector: 'rt-select2[alwaysOpen]',
  providers: [provideOpenStrategy(AlwaysOpenStrategy, StrategyRelevance.Custom)],
})
export class AlwaysOpenStrategyDirective {}
